const $ = jQuery.noConflict();

class MegaMenu {
    constructor() {
        this.header = $('.main-header');
        this.menuItems = this.header.find('.main-header__main-nav > ul > li > a');
        this.megaMenu = this.menuItems.next('.mega-menu');
    }

    init() {
        this.menuItems.on('click', this.toggleMegaMenu.bind(this));
        this.menuItems.hover( (e) => {
            this.menuItems.addClass('faded');
            $(e.target).removeClass('faded');
        }, () => {
            this.menuItems.removeClass('faded');
        });
    }

    toggleMegaMenu(e) {
        const item = $(e.delegateTarget);
        const megaMenu = item.next('.mega-menu');

        if (!megaMenu.length) {
            return;
        }

        e.preventDefault();
        if (megaMenu.hasClass('active')) {
            this.hideMegaMenu();
            return;
        }
        this.hideMegaMenu();
        this.showMegaMenu(item, megaMenu);
    }

    showMegaMenu(item, megaMenu) {
        this.menuItems.addClass('inactive');

        item.removeClass('inactive').addClass('active').parent().addClass('active');
        megaMenu.addClass('active');
    }

    hideMegaMenu() {
        this.menuItems.removeClass('inactive active');
        this.megaMenu.removeClass('active').parent().removeClass('active');
    }
}

export default new MegaMenu();
